import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import {
	COVER_BADGE_BG_COLOR,
	COVER_TEXT_COLOR,
} from "../AnimatedHeaderScreen/constants";
import { AppIcon } from "../AppIcon";
import Box from "../Box";
import type { LessonDetailMetaChip } from "./types";

type Props = {
	chips: LessonDetailMetaChip[];
	invertColors?: boolean;
};

export const LessonDetailMetaChips = ({ chips, invertColors }: Props) => {
	const theme = useAppTheme();

	if (!chips.length) {
		return null;
	}

	const backgroundColor = invertColors
		? COVER_BADGE_BG_COLOR
		: theme.colors.elevation.level1;
	const foregroundColor = invertColors
		? COVER_TEXT_COLOR
		: theme.colors.onSurfaceVariant;

	return (
		<Box flexDirection="row" flexWrap="wrap" gap={4}>
			{chips.map((chip) => (
				<Box
					key={chip.label}
					flexDirection="row"
					alignItems="center"
					gap={4}
					paddingHorizontal={8}
					paddingVertical={6}
					borderRadius={theme.roundness * 100}
					backgroundColor={backgroundColor}
				>
					{chip.iconName ? (
						<AppIcon name={chip.iconName} size={16} color={foregroundColor} />
					) : null}
					<Text
						variant="labelMedium"
						numberOfLines={1}
						style={{ color: foregroundColor }}
					>
						{chip.label}
					</Text>
				</Box>
			))}
		</Box>
	);
};
